var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"py-0 my-0",attrs:{"fluid":"","fill-height":""}},[_c('v-row',{staticStyle:{"height":"100%"},attrs:{"justify":"center"}},[_c('v-col',{staticClass:"py-0 my-0 px-0",staticStyle:{"height":"100%"}},[_c('v-card',{staticClass:"py-0 my-0 px-0",staticStyle:{"height":"100%"}},[_c('initial-frame')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }